<template>
    <div class="data-property-wrap">
        <el-card shadow="hover" class="document-card">

            <!-- 顶部操作栏 -->
            <div class="toolbar">
                <el-button type="primary" icon="el-icon-plus" @click="checkAuthBeforeRegistration">
                    登记申请
                </el-button>
                <el-input
                    v-if="currentName === ''"
                    v-model="keywords"
                    placeholder="请输入资产名称..."
                    class="search-input"
                    clearable
                    @keydown.enter.native="doSearch"
                    @clear="doSearch">
                    <el-button slot="append" icon="el-icon-search" @click="doSearch">搜索</el-button>
                </el-input>
            </div>

            <component v-bind:is="currentName" @changeName="changeName"></component>

            <div v-if="currentName === ''" class="table-wrap">
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }"
                    :row-class-name="tableRowClassName">

                    <el-table-column type="index" label="序号" width="55" align="center" />

                    <el-table-column prop="registrationId" label="资产登记编号" min-width="170" align="center" show-overflow-tooltip />

                    <el-table-column prop="assetName" label="资产登记名称" min-width="200" align="center" show-overflow-tooltip />

                    <el-table-column prop="dataSource" label="数据来源" min-width="90" align="center" show-overflow-tooltip />

                    <el-table-column prop="industry" label="行业类别" min-width="180" align="center" show-overflow-tooltip />

                    <el-table-column prop="updateCycle" label="周期" min-width="70" align="center" />

                    <el-table-column prop="state" label="状态" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tooltip v-if="scope.row.state === '已颁发证书'" content="点击下载证书" placement="top">
                                <el-tag
                                    :type="getStatusTagType(scope.row.state)"
                                    size="small"
                                    class="status-tag status-tag--clickable"
                                    @click.native="handleDownloadCertificate(scope.row)">
                                    <i class="el-icon-download" /> {{ scope.row.state }}
                                </el-tag>
                            </el-tooltip>
                            <el-tooltip v-else-if="scope.row.state === '平台公示中'" content="打开公示页面" placement="top">
                                <el-tag
                                    :type="getStatusTagType(scope.row.state)"
                                    size="small"
                                    class="status-tag status-tag--clickable"
                                    @click.native="handleOpenPublicPage(scope.row)">
                                    <i class="el-icon-link" /> {{ scope.row.state }}
                                </el-tag>
                            </el-tooltip>
                            <el-tag v-else :type="getStatusTagType(scope.row.state)" size="small" class="status-tag">
                                {{ scope.row.state }}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="creator" label="申请时间" min-width="160" align="center" />

                    <el-table-column prop="updater" label="证书颁发时间" min-width="160" align="center" />

                    <el-table-column prop="otherFile" label="证书有效期" min-width="160" align="center" />

                    <el-table-column label="操作" width="160" align="center" fixed="right">
                        <template slot-scope="scope">
                            <div class="op-btns">
                                <template v-if="scope.row.state === '录入中' || scope.row.state === '审核驳回'">
                                    <el-button size="mini" type="success"  @click="handleEdit(scope.row)">编辑</el-button>
                                    <el-button v-if="scope.row.state === '录入中'" size="mini" type="danger"  @click="handleDelete(scope.row)">删除</el-button>
                                </template>
                                <el-button v-else size="mini" type="primary" @click="handleView(scope.row)">查看详情</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>

        <div v-if="currentName === ''" class="pagination-wrap">
            <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="boardsTotal"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :current-page="currPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :pager-count="5"
                :background="true" />
        </div>
    </div>
</template>

<script>
import AddBoardContent from "../../components/AddBoardContent";

export default {
    name: "PublishBoard",
    data() {
        return {
            boardsTotal: 1,
            currPage: 1,
            pageSize: 10,
            keywords: '',
            currentName: '',
            tableData: [],
        }
    },
    components: {
        AddBoardContent
    },
    watch: {},
    mounted() {
        this.initTableData('');
    },
    methods: {
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData(this.keywords);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.initTableData(this.keywords);
        },
        initTableData(keyword) {

            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useId:  " + user.id)


            this.getRequest('/web/dataAssets/queryList?keyword=' + keyword + '&userId=' + user.id + '&currPage=' + this.currPage + '&pageSize=' + this.pageSize).then(resp => {
                //console.log(resp.data);
                if (resp) {
                    this.boardsTotal = resp.data.total;
                    this.tableData = resp.data.list;
                }
            });
        },
        doSearch() {
            this.$router.push({
                path: this.$route.path,
                query: { ...this.$route.query, keyword: this.keywords }
            });
            this.initTableData(this.keywords);
        },
        changeName(name) {
            //console.log(this.currentName)
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },
        handleDelete(obj) {
            this.$confirm('是否永久删除名为：【' + obj.assetName + '】的数据资产？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.axios.get("/web/dataAssets/delete?registrationId=" + obj.registrationId).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('删除成功');
                        this.initTableData('');
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        publishedSwitch(obj) {
            this.getRequest('/web/changeBoard/published?id=' + obj.id + '&published=' + obj.published).then(() => {
            });
        },
        async checkAuthBeforeRegistration() {
            try {
                const user = JSON.parse(window.localStorage.getItem('user'));
                const response = await this.$axios.get('/web/companyDetail/query?userId=' + user.id);

                if (response.data.authState !== '认证成功') {
                    this.$message.warning('您未完成企业信息认证，请先认证');
                    return;
                }

                this.$router.push('/index/data-registration');
            } catch (error) {
                console.error('检查认证状态失败:', error);
                this.$message.error('检查认证状态失败，请稍后重试');
            }
        },
        getStatusStyle(state) {
            switch (state) {
                case '录入中': return { color: '#67C23A' };
                case '审核中': return { color: '#67C23A' };
                case '审核驳回': return { color: '#F56C6C' };
                case '审核通过': return { color: '#409EFF' };
                case '已颁发证书': return { color: '#409EFF' };
                case '平台公示中': return { color: '#409EFF' };
                default: return {};
            }
        },
        getStatusTagType(state) {
            switch (state) {
                case '录入中': return 'warning';
                case '审核中': return 'warning';
                case '审核驳回': return 'danger';
                case '审核通过': return 'success';
                case '已颁发证书': return 'success';
                case '平台公示中': return 'info';
                default: return 'info';
            }
        },
        tableRowClassName({ rowIndex }) {
            if (rowIndex % 2 === 1) {
                return 'stripe-row';
            }
            return '';
        },
        handleView(row) {
            this.$router.push({
                path: '/index/review-page-view',
                query: { registrationId: row.registrationId }
            });
        },
        handleEdit(row) {
            this.$router.push({
                path: '/index/data-registration',
                query: { registrationId: row.registrationId, mode: 'edit' }
            });
        },

        async handleDownloadCertificate(row) {
            if (row.state === '已颁发证书') {
                try {
                    const response = await this.$axios({
                        method: 'get',
                        url: '/web/certificate/download',
                        params: {
                            registrationId: row.registrationId,
                            filename: row.registrationId + '.pdf'
                        },
                        responseType: 'blob'
                    });
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', row.registrationId + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } catch (error) {
                    console.error('证书下载失败:', error);
                    this.$message.error('证书下载失败: ' + error.message);
                }
            }
        },
        handleOpenPublicPage(row) {
            if (row.state === '平台公示中') {
                const url = this.$router.resolve({
                    path: '/infoPublic'
                }).href;
                window.open(url, '_blank');
            }
        }
    }
}
</script>

<style scoped>
.data-property-wrap {
    padding: 20px 30px;
}

.document-card {
    border-radius: 8px;
    overflow: hidden;
}

/* 顶部工具栏 */
.toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 16px;
}

.search-input {
    width: 350px;
}

.search-input >>> .el-input-group__append {
    background-color: #409EFF;
    color: white;
    border-color: #409EFF;
    cursor: pointer;
    transition: background-color 0.3s;
}

.search-input >>> .el-input-group__append:hover {
    background-color: #66b1ff;
}

/* 表格容器 */
.table-wrap {
    margin-top: 20px;
}

/* 表格斑马纹 */
.document-card >>> .el-table .stripe-row {
    background: #fafafa;
}

/* 表格hover效果 */
.document-card >>> .el-table__row:hover {
    background: #f0f9ff !important;
}

/* 状态标签 */
.status-tag {
    font-weight: 500;
    padding: 4px 10px;
}

.status-tag--clickable {
    cursor: pointer;
    transition: all 0.2s;
}

.status-tag--clickable:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.status-tag i {
    margin-right: 2px;
}

/* 操作列按钮组 */
.op-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
}

/* 按钮统一样式 */
.el-button--mini {
    min-width: 60px;
    height: 28px;
    line-height: 1;
    padding: 7px 12px;
    border-radius: 4px;
    font-size: 12px;
    transition: all 0.3s;
}

/* 编辑按钮效果 */
.el-button--success {
    background-color: #67C23A;
    border-color: #67C23A;
}

.el-button--success:hover {
    background-color: #85ce61 !important;
    border-color: #85ce61 !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(103, 194, 58, 0.3);
}

.el-button--success:active {
    transform: translateY(0);
    box-shadow: none;
}

/* 删除按钮效果 */
.el-button--danger {
    background-color: #F56C6C;
    border-color: #F56C6C;
}

.el-button--danger:hover {
    background-color: #f78989 !important;
    border-color: #f78989 !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(245, 108, 108, 0.3);
}

.el-button--danger:active {
    transform: translateY(0);
    box-shadow: none;
}

/* 查看详情按钮 */
.el-button--primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
}

.el-button--primary:active {
    transform: translateY(0);
    box-shadow: none;
}

/* 分页容器 */
.pagination-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

/* 分页组件优化 */
.pagination-wrap >>> .el-pagination.is-background {
    padding: 15px 0;
}

.pagination-wrap >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409EFF;
    color: #fff;
    font-weight: bold;
}

.pagination-wrap >>> .el-pagination.is-background .el-pager li:hover {
    color: #409EFF;
}

.pagination-wrap >>> .el-pagination__jump {
    margin-left: 10px;
}

/* 表头样式 */
.document-card >>> .el-table__header th {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
}

/* 响应式 */
@media (max-width: 1200px) {
    .toolbar {
        flex-direction: column;
        align-items: stretch;
    }

    .search-input {
        width: 100%;
    }
}
</style>
